const blue = '#064367';
const blueActive = '#075478';

export default {
  buttonBorderRadius: '8px',
  cardBorderRadius: '14px',
  cardBoxShadow: '0 1px 2px 0 rgb(0 20 40 / 10%)',
  cardBoxShadowActive:
    '0 1px 2px 0 rgb(0 20 40 / 5%), 0 1px 20px -2px rgb(0 20 40 / 10%)',
  certificateHighlightColor: blue,
  certificateLogoWidth: 150,
  chartMainColor: blue,
  dangerColor: '#c4163c',
  dangerColorActive: '#d5274d',
  dangerLightColor: '#f5e1e5',
  dangerLightTextColor: '#bb0022',
  dangerTextColor: '#fff',
  dropdownBorderRadius: '10px',
  dropdownShadow:
    'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
  emailLogoLanguageVariants: null,
  emailLogoWidth: 140,
  emailLogoWidthLanguageVariants: null,
  headerBackgroundColor: '#fff',
  headerButtonBackgroundColor: '#ecf2f6',
  headerButtonBackgroundColorHover: '#e5eaf1',
  headerIconColor: '#5f6f7f',
  headerPadding: '15px 0',
  headerTextColor: '#2d3b4d',
  inputBorderRadius: '6px',
  lightGrey: '#ecf2f6',
  lightGreyActive: '#e5eaf1',
  lightGreyDark: '#e0e8ef',
  lightGreyDarkActive: '#d9e2e8',
  lightGreyLighter: '#f3f7fa',
  linkColor: blue,
  loginBackgroundColor: '#f6f9fb',
  logo: '/static/img/vuo-logo-sininen.svg',
  logoLanguageVariants: null,
  logoWidth: 140,
  logoWidthLanguageVariants: null,
  mainColor: blue,
  mainColorActive: blueActive,
  mainTextColor: '#fff',
  mobileLogoWidth: 132,
  pageBackgroundColor: '#f3f7fa',
  pageIconBackgroundColor: 'white',
  pageIconTextColor: '#2d3b4d',
  pageIconTextColorLighter: '#5f6f7f',
  pageTextColor: '#2d3b4d',
  pageTextColorLighter: '#5f6f7f',
  subHeaderBackgroundColor: blue,
  subHeaderColor: 'rgba(255, 255, 255, 0.8)',
  subHeaderColorActive: '#fff',
  successColor: '#1b9461',
  successColorActive: '#2ca372',
  successColorDark: '#9b8',
  successColorDarkActive: '#ac9',
  successLightColor: '#dfefe6',
  successLightTextColor: '#116600',
  successStandaloneColor: '#1b9461',
  successTextColor: '#fff',
  successTextColorDark: '#fff',
  textColor: '#2d3b4d',
  textColorLight: '#456',
  textColorLighter: '#5f6f7f',
  warningColor: '#f9d717',
  warningLightColor: '#f5f0c5',
  warningLightTextColor: '#664400',
  warningStandaloneColor: '#c67c0a',
  warningTextColor: '#333'
};
